import React, {useMemo} from "react";
import Page from "../../common/page/Page.js";
import useTranslationAdmin from "../useTranslationAdmin.js";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import WithRedirectionUserIsAuthorized from "../../authentication-ui/WithRedirectionUserIsAuthorized.js";
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import DetailedJobListBlock from "./DetailedJobListBlock.js";


export default function DetailedJobListPage(/*props*/) {
  const { t, loading: tLoading } = useTranslationAdmin();
  useShowLoader(tLoading, "DetailedJobListPage");
  const location = useLocation()

  const filter = useMemo(() => queryString.parse(location.search), [location.search]);

  return (
    <WithRedirectionUserIsAuthorized
      yes={() => (
        <Page className="DetailedJobListPage">
          <Page.Title
            text={t("admin:admin_job_list_title")}
            loading={tLoading}
          />
          <Page.Content>
            <DetailedJobListBlock filter={filter}/>
          </Page.Content>
        </Page>
      )}
    />
  );
}
